export default "__VITE_ASSET__8uJ9qlHK__"